import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

export const Burger = ({ menuIsOpen, ...rest }) => (
  <div className={cn(styles.Burger, { [styles.BurgerActive]: menuIsOpen })} {...rest}>
    <span />
    <span />
    <span />
    <span />
  </div>
)
